import { api } from "@data-phone/react-resource-server-auth";
import { setAppsSuccess, setAppsError, setAppsLoading } from "../redux/slices/apps.slice";
import { useApiQuery } from "../hooks/useApiQuery";

export type AppsType =
    | "conference"
    | "extension"
    | "fax_server"
    | "flow"
    | "ivr_menu"
    | "paging_group"
    | "queue"
    | "ring_group";

export interface AppItem {
    id: string;
    name: string;
    extension: string;
}

type RawAppsResponse = {
    [key in AppsType]?: {
        id: string;
        name?: string;
        extension?: string;
    }[];
};

export const fetchApps = async (): Promise<RawAppsResponse> => {
    const response = await api.get(
        `${process.env.REACT_APP_LIVE_CALL_URL}/api/apps`
    );
    return response.result;
};


export const useGetApps = () => {
    return useApiQuery(
        ['apps'],
        fetchApps,
        {
            actions: {
                setLoading: setAppsLoading,
                setSuccess: setAppsSuccess,
                setError: setAppsError
            },
            enabled: false
        }
    );
};

export const appsService = {
    fetchApps,
};

export default appsService;
